import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SummarizeService } from '../summarize.service';
// import { error } from 'console';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertPopup, HttpLoader } from 'app/app.config';
import { LlmService } from 'app/services/llm.service';
import { finalize } from 'rxjs';
// import * as console from 'console';


@Component({
  selector: 'app-summarize-content',
  templateUrl: './summarize-content.component.html',
  styleUrls: ['./summarize-content.component.scss'],
  standalone: false
})
export class SummarizeContentComponent implements OnInit {

  @Output() summaryResponse = new EventEmitter<any>();

  summarizeForm!: FormGroup;

  submitted = false;
  summarization: any;

  showPaginateSpinner = false;
  showPageLoader = false;

  constructor(
    private fb: FormBuilder,
    private summaryService: SummarizeService,
    private alert: AlertPopup,
    private llmService: LlmService,
    private httpLoader: HttpLoader
  ) {}

  ngOnInit(): void {

    this.summarizeForm = this.fb.group({
      summary: ['', Validators.required]
    });

  }

  // Upload PDF and extract text
  chooseUploadFile(event: Event): void {

    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) {
      return;
    }

    const resetInput = (): void => {
      input.value = '';
    };

    // Validate PDF
    const isPdf =
      file.type === 'application/pdf' ||
      file.name.toLowerCase().endsWith('.pdf');

    if (!isPdf) {

      this.alert.showAlertMessage({
        message: 'Please select a valid PDF file.'
      });

      resetInput();
      return;
    }

    // Validate company ID
    const companyId = localStorage.getItem('company_id');

    if (!companyId) {

      this.alert.showAlertMessage({
        message: 'Company ID not found. Please log in again.'
      });

      resetInput();
      return;
    }

    const formData = new FormData();

    formData.append('clientid', companyId);
    formData.append('file', file, file.name);

    this.showPageLoader = true;

    this.summaryService
      .uploadSummaryPdf(formData)
      .pipe(
        finalize(() => {
          this.showPageLoader = false;
          resetInput();
        })
      )
      .subscribe({

        next: (res: any) => {

          const extractText =
            typeof res?.result === 'string'
              ? res.result.trim()
              : '';

          if (extractText.length < 5) {

            this.alert.showAlertMessage({
              message: 'Unable to extract text. Please upload a valid PDF file.'
            });

            return;
          }

          const summaryControl = this.summarizeForm.get('summary');

          summaryControl?.setValue(extractText);
          summaryControl?.markAsDirty();
          summaryControl?.updateValueAndValidity();

        },

        error: (error: HttpErrorResponse) => {

          console.error('PDF upload failed:', error);

          this.alert.showAlertMessage({
            message:
              error.error?.message ||
              'PDF upload failed. Please try again.'
          });

        }

      });

  }

  // Generate summary
  postSummary(): void {

    this.submitted = true;

    if (this.summarizeForm.invalid) {

      this.summarizeForm.markAllAsTouched();
      return;
    }

    const summaryText = String(
      this.summarizeForm.get('summary')?.value ?? ''
    ).trim();

    if (!summaryText) {

      this.alert.showAlertMessage({
        message: 'Please enter text to summarize.'
      });

      return;
    }

    const payload = {
      query: `summary of text "${summaryText}"`
    };

    this.showPageLoader = true;
    this.httpLoader.showLoader();

    this.llmService
      .llmGenericQuery(payload)
      .pipe(
        finalize(() => {
          this.showPageLoader = false;
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({

        next: (result: any) => {

          const formattedResponse =
            result?.formatted_response;

          if (!formattedResponse) {

            this.alert.showAlertMessage({
              message: 'Unable to generate the summary. Please try again.'
            });

            return;
          }

          this.summaryResponse.emit(formattedResponse);

          this.summarizeForm.reset();
          this.submitted = false;

        },

        error: (error: HttpErrorResponse) => {

          console.error('Summary generation failed:', error);

          this.alert.showAlertMessage({
            message:
              error.error?.message ||
              'Failed to generate summary. Please try again.'
          });

        }

      });

  }

  // Reset form
  resetSummary(): void {

    this.summarizeForm.reset({
      summary: ''
    });

    this.submitted = false;

  }

}
